import React, { Fragment } from "react";
import style from "../../../scss/Resultado.module.scss";

const ResultadoComponent = (props) => {
  const cantidadreal = props.cantidad.toLocaleString();
  return (
    <Fragment>
      <div className={style.badge}>
        <span>🗳️ Sufragantes</span>
        <strong>{cantidadreal}</strong>
      </div>
    </Fragment>
  );
};

export default ResultadoComponent;